var map = {
	"./Dark.webp": 86,
	"./Fire.webp": 172,
	"./Ice.webp": 145,
	"./Light.webp": 39,
	"./Slash.webp": 228,
	"./Stab.webp": 240,
	"./Strike.webp": 600,
	"./Thunder.webp": 989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 226;